module.exports = __webpack_public_path__ + "static/media/vocabulary.926aa5e6.svg";